import { clearAuthStorage, setOrgaizationSettings } from "./storage";
import axios from "axios";

export const formatLabel = (label) => {
  return label
    .split("_") // split by underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each word
    .join(" "); // join with spaces
};

export const handleLogout = () => {
  console.log("Handle Logout was clicked");

  clearAuthStorage();
  window.location.href = "/login";
};

export function extractErrors(errorObj) {
  if (!errorObj) return [];

  // if it has an "errors" wrapper
  if (errorObj.errors) {
    return Object.values(errorObj.errors).flat();
  }

  // if the errors are at the root level
  return Object.values(errorObj).flat();
}

export function normalizeUrl(url) {
  return url.replace(/\\\//g, "/");
}

export function moneyFormat(strNumber, locale = "en-US") {
  // Convert string to number
  const num = parseFloat(strNumber);

  // Handle invalid numbers
  if (isNaN(num)) return "Invalid number";

  // Format using Intl.NumberFormat
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

export function moneyFormatWithCurrency(
  strNumber,
  currency = "USD",
  locale = "en-US"
) {
  // Convert string to number
  const num = parseFloat(strNumber);

  // Handle invalid numbers
  if (isNaN(num)) return "Invalid number";

  // Format using Intl.NumberFormat
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(num);
}

export function formatDateShort(dateString) {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date)) return "Invalid Date";

  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short", // short month name like Jan, Feb, Mar
    year: "numeric",
  }).format(date);
}

export function calculateTotalCurrencyAmount(wallets, currency) {
  let total = 0;
  for (const w of wallets) {
    const from = getCurrencyCode(w);
    const amount = parseFloat(w.balance || 0);
    if (from === currency) {
      total += amount;
    } else if (amount > 0) {
      // Convert to selected currency
      // const res = await getExchangeRate({
      //   from: from,
      //   to: overviewCurrency,
      //   amount: amount,
      // });
      // if (res.status && res.data && res.data.quote_amount) {
      //   total += parseFloat(res.data.quote_amount);
      // }
    }
  }
  return total;
}

export function getCurrencyCode(wallet) {
  if (!wallet) return "N/A";

  if (wallet.provider_metadata) {
    try {
      const meta = JSON.parse(wallet.provider_metadata);
      if (meta.currency) return meta.currency;
    } catch { }
  }

  // Handle case where currency might be an object
  const currencyCode =
    typeof wallet.currency === "object"
      ? wallet.currency?.code
      : wallet.currency;
  const currencyName =
    typeof wallet.currency === "object" ? wallet.currency?.name : null;

  return currencyCode || currencyName || "N/A";
}

export const initCompanyFromSubdomain = async (defaultUrl = undefined) => {

  var customUrl = defaultUrl ? defaultUrl.split(".") : window.location.hostname.split(".");
 
  const hostParts = customUrl;

  // List of reserved subdomains you want to ignore
  const reservedSubdomains = ["www", "api", "mail", "ftp", "webmail", "smtp", "pop", "imap", 'app'];

  // Extract subdomain (if hostname has 3+ parts)
  let subdomain = hostParts.length > 2 ? hostParts[0].toLowerCase() : null;

  // If subdomain is reserved, ignore it
  if (reservedSubdomains.includes(subdomain)) {
    subdomain = null;
  }

  // Get domain (last two parts)
  const domain = hostParts.slice(-2).join(".");

  // Get `company` from URL param
  // const urlParams = new URLSearchParams(window.location.search);
  // const companyName = urlParams.get("company");

  // Choose identifier: GET param > valid subdomain > domain
  // const currentIdentifier = (companyName || subdomain || domain)?.toLowerCase().trim();
  const currentIdentifier = (subdomain || domain)?.toLowerCase().trim();

  // Safely parse session storage
  const storedCompanyRaw = sessionStorage.getItem("company");
  const storedCompany = storedCompanyRaw ? JSON.parse(storedCompanyRaw) : null;

  const storedCompanyId = sessionStorage.getItem("beller_app_id");
  const storedCompanyKey = sessionStorage.getItem("company_key");

  // console.log("Subdomain:", subdomain);
  // console.log("Domain:", domain);
  // console.log("GET Param:", companyName);
  // console.log("Final Identifier:", currentIdentifier);

  // ⚠️ If company already loaded from same subdomain/company param, reuse it
  if (storedCompany && storedCompanyKey === currentIdentifier) {
    // console.log(storedCompanyId);
    console.log(storedCompany);

    return storedCompany;
  }

  sessionStorage.clear();

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}organizations/${currentIdentifier}`
    );
    const company = response?.data?.data;

    setOrgaizationSettings(company);

    // Save everything
    sessionStorage.setItem("beller_app_id", company?.id);
    sessionStorage.setItem("company", JSON.stringify(company));
    sessionStorage.setItem("company_key", currentIdentifier); // track current company source

    return company;
  } catch (error) {
    console.error("Company fetch failed", error);
    return null;
  }
};
